import { render, staticRenderFns } from "./employeeRoles.vue?vue&type=template&id=63c57e34&scoped=true"
import script from "./employeeRoles.vue?vue&type=script&lang=js"
export * from "./employeeRoles.vue?vue&type=script&lang=js"
import style0 from "./employeeRoles.vue?vue&type=style&index=0&id=63c57e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c57e34",
  null
  
)

export default component.exports